export default __webpack_public_path__ + "static/media/brandtab_banner.bb3679f5.png";